module.exports = __webpack_public_path__ + "img/cjje.e8ccd7d2.png";